import React, { useState, useRef, useMemo } from 'react';
import RadarPlot from '../RadarPlot/RadarPlot.esm.js';
import { adjustQuadrants, adjustRings, adjustEntries } from './utils.esm.js';

const Radar = ({
  width,
  height,
  quadrants,
  rings,
  entries,
  ...props
}) => {
  const radius = Math.min(width, height) / 2 - (rings.some((ring) => ring.description) ? 16 : 0);
  const [activeEntry, setActiveEntry] = useState();
  const node = useRef(null);
  const adjustedQuadrants = useMemo(
    () => adjustQuadrants(quadrants, radius, width, height),
    [quadrants, radius, width, height]
  );
  const adjustedRings = useMemo(
    () => adjustRings(rings, radius),
    [radius, rings]
  );
  const adjustedEntries = useMemo(
    () => adjustEntries(
      entries,
      adjustedQuadrants,
      adjustedRings,
      radius,
      activeEntry
    ),
    [entries, adjustedQuadrants, adjustedRings, radius, activeEntry]
  );
  return /* @__PURE__ */ React.createElement("svg", { ref: node, width, height, ...props.svgProps }, /* @__PURE__ */ React.createElement(
    RadarPlot,
    {
      width,
      height,
      radius,
      entries: adjustedEntries,
      quadrants: adjustedQuadrants,
      rings: adjustedRings,
      activeEntry,
      onEntryMouseEnter: (entry) => setActiveEntry(entry),
      onEntryMouseLeave: () => setActiveEntry(void 0)
    }
  ));
};

export { Radar as default };
//# sourceMappingURL=Radar.esm.js.map
